import { render, staticRenderFns } from "./set-catalog.vue?vue&type=template&id=046f1c70&scoped=true&lang=pug&"
import script from "./set-catalog.vue?vue&type=script&lang=js&"
export * from "./set-catalog.vue?vue&type=script&lang=js&"
import style0 from "./set-catalog.vue?vue&type=style&index=0&id=046f1c70&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f1c70",
  null
  
)

export default component.exports